<template>
    <h1 class="logo">
        <router-link v-bind="{ to, title }">
            <!-- <span class="d-sr-only"><slot /></span> -->
            <slot />
        </router-link>
    </h1>
</template>

<script>
export default {
    props: {
        to: { type: String, default: "/" },
        title: { type: String, default: "홈으로 이동" },
    },
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.logo {
    // width: var(--logo-width);
    // height: var(--logo-height);
    a {
        display: block;
        width: 100%;
        height: 100%;
        // background-image: url(/images/logo.svg);
        // background-repeat: no-repeat;
        // background-position: center;
        // background-size: contain;
        font-family: var(--font-secondary);
        font-size: 2.6rem;
        color: var(--v-primary-base);
        font-weight: 700;
    }
    // &--light {
    //     a {
    //         background-image: url(/images/logo-light.svg);
    //     }
    // }
    &--dark {
        a {
            // background-image: url(/images/logo-dark.svg);
            color: #8f8f8f;
        }
    }
}
// .header {
//     .logo {
//         width: var(--header-logo-width);
//         height: var(--header-logo-height);
//     }
// }

@media (min-width: 1024px) {
    .logo > a {
        font-size: 3rem;
    }
}
</style>
